import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { PromotionController } from 'infraestructure/controllers/promotionController'
import { Status } from 'domain/models/apiResponse'
import { UpdatePromotionCommandRequest } from 'domain/entities/promotion'
import {
  promotionState,
  updatePromotionError,
  updatePromotionStart,
  updatePromotionSuccess,
} from 'presentation/redux/slices/promotionSlice'
import useError from 'presentation/hooks/useError'

export const useUpdatePromotion = () => {
  const dispatch = useDispatch()
  const { isLoading, errorUpdatePromotion } = useSelector(promotionState)
  const { getErrorMessage } = useError()

  const updatePromotion = useCallback(
    async (promotionId: string, data: UpdatePromotionCommandRequest) => {
      dispatch(updatePromotionStart())
      try {
        const response = await PromotionController.updatePromotion(promotionId, data)
        if (response?.status === Status.success) {
          dispatch(updatePromotionSuccess())
          return true
        }
      } catch (err: any) {
        dispatch(updatePromotionError(getErrorMessage({ error: err })))
        return false
      }
    },
    [dispatch, getErrorMessage],
  )

  return { updatePromotion, isLoading, errorUpdatePromotion }
}
